import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MentenancePlanningState {
  allData: any[];
  selectionData: any[];
  scheduledMentenancePlanningData: any[];
  reschedulingRequestMentenancePlanningData: any[];
  historyMentenancePlanningData: any[];
  myActiveRequestMentenancePlanningData: any[];
  myHistoryMentenancePlanningData: any[];
  myReportMentenancePlanningData: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: MentenancePlanningState = {
  allData: [],
  selectionData: [],
  historyMentenancePlanningData: [],
  reschedulingRequestMentenancePlanningData: [],
  scheduledMentenancePlanningData: [],
  myActiveRequestMentenancePlanningData: [],
  myHistoryMentenancePlanningData: [],
  myReportMentenancePlanningData: [],
  isLoading: false,
  error: null,
};

const MentenancePlanningSlice = createSlice({
  name: 'mentenancePlanning',
  initialState,
  reducers: {
    setMentenancePlannings: (state, action: PayloadAction<any[]>) => {
      state.allData = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setSelectedMentenancePlannings: (state, action: PayloadAction<any[]>) => {
      state.selectionData = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setHistoryMentenancePlannings: (state, action: PayloadAction<any[]>) => {
      state.historyMentenancePlanningData = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setReschedulingRequestMentenancePlannings: (state, action: PayloadAction<any[]>) => {
      state.reschedulingRequestMentenancePlanningData = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setScheduledMentenancePlannings: (state, action: PayloadAction<any[]>) => {
      state.scheduledMentenancePlanningData = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setMyActiveMentenancePlannings: (state, action: PayloadAction<any[]>) => {
      state.myActiveRequestMentenancePlanningData = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setMyHistoryMentenancePlannings: (state, action: PayloadAction<any[]>) => {
      state.myHistoryMentenancePlanningData = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setReportMentenancePlannings: (state, action: PayloadAction<any[]>) => {
      state.myReportMentenancePlanningData = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setMentenancePlanningLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setMentenancePlanningError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  setMentenancePlannings,
  setSelectedMentenancePlannings,
  setHistoryMentenancePlannings,
  setReschedulingRequestMentenancePlannings,
  setScheduledMentenancePlannings,
  setMentenancePlanningLoading,
  setMentenancePlanningError,
  setMyActiveMentenancePlannings,
  setMyHistoryMentenancePlannings,
  setReportMentenancePlannings,
} = MentenancePlanningSlice.actions;

export default MentenancePlanningSlice.reducer;
